import { ConversationStep, Theme } from "../../interfaces";
import { getApplicantSteps } from "../ApplicantSteps";
import AppointmentSteps from "../AppointmentSteps";
import ProtectionSteps from "../ProtectionSteps";
import DefaultSteps from "../DefaultSteps";
import EscalationSteps from "../EscalationSteps";

const Protection = (theme: Theme) => {
  let mainFlow = theme?.customFlowData?.flow || [];
  if (theme.customFlowData) {
    if (theme.customFlowData.importedFlows) {
      const importedFlows = theme.customFlowData?.importedFlows.map(
        (data: any) => data.flow
      );
      let combinedImportedFlows: any = [];
      importedFlows.forEach((data: any) =>
        data.forEach((_data: any) => combinedImportedFlows.push(_data))
      );
      mainFlow = [...mainFlow, ...combinedImportedFlows];
    }
  }

  return [
    ...mainFlow,
    {
      id: "1",
      type: "bot",
      message: "Hey! 👋",
      trigger: "2",
    },
    {
      id: "2",
      type: "bot",
      message: `My name is <strong>${theme?.customization?.botName}</strong>, and I help people with their insurance needs.`,
      trigger: "household",
    },
    ...ProtectionSteps(theme),
    ...AppointmentSteps(theme),
    ...DefaultSteps(theme),
    ...getApplicantSteps(1),
    ...getApplicantSteps(2),
    ...EscalationSteps,
  ] as ConversationStep[];
};

export default Protection;
